import { dashboardApi } from '@/store/api/base/api.base';
import beauthBrowser from '@/lib/beauth/beauth.browser';
import { sessionClosed } from '@/store/auth/auth.slice';
import type { TypeSessionUser } from '@/types/auth/types.auth.session';

export const authApi = dashboardApi.injectEndpoints({
    endpoints: (build) => ({
        readMe: build.query<TypeSessionUser, void>({
            query: () => ({ url: '/auth/me' }),
        }),

        logout: build.mutation<null, void>({
            queryFn: async () => {
                await beauthBrowser.signOut().catch(() => undefined);
                return { data: null };
            },
            onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
                try { await queryFulfilled; } catch { } finally {
                    dispatch(sessionClosed());
                    dispatch(dashboardApi.util.resetApiState());
                }
            },
        }),
    }),
});

export const { useReadMeQuery, useLogoutMutation } = authApi;

export default authApi;
